export const tableColumns = [
  {
    label: "统计名称",
    value: "sheetName"
  },
  {
    label: "类型",
    value: "_type"
  },
  {
    label: "类型ID",
    value: "typeId"
  },
  {
    label: "刷新间隔",
    value: "_refreshInterval"
  }
]
